// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/theme.css'

// Direction
document.documentElement.setAttribute(
  'dir',
  i18n.global.locale.value === 'ar' ? 'rtl' : 'ltr'
)

// Theme init: saved > dark (default)
const saved = localStorage.getItem('theme')
const initialTheme = saved || 'dark'
document.documentElement.setAttribute('data-theme', initialTheme)

const app = createApp(App)
app.use(i18n)
app.use(router).mount('#app')
